import React from 'react'
import { Col, Row, Button } from 'reactstrap'
import { connect, useDispatch } from 'react-redux'
import ReactSelect from 'react-select'
import useFetchingCompany from './useFetchingCompany'
import { companySelected } from '../actions/companyActionCreators'
import { Link } from 'react-router-dom'
import LoadingSpinner from '../Shared/LoadingSpinner'
import HeaderRow from '../Shared/LayoutComponents/HeaderRow'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const CreateCompanySelect = (props) => {
  useFetchingCompany()
  const dispatch = useDispatch()

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <HeaderRow center>
              <PageHeading>1. Select a ConnectWise Client</PageHeading>
            </HeaderRow>
            <HeaderRow center>
              <div style={{ width: '100%' }}>
                <ReactSelect
                  value={props.createSelected}
                  onChange={(property, value) => dispatch(companySelected(property))}
                  isClearable
                  isSearchable
                  options={props.createCompanyList}
                />
              </div>
            </HeaderRow>
            <HeaderRow between>
              <Link to="/">
                <Button outline color="secondary">
                  Cancel
                </Button>
              </Link>
              <Link disabled={props.createSelected ? false : true} to="/Create/Agreement">
                <Button color="primary" disabled={props.createSelected ? false : true}>
                  Next
                </Button>
              </Link>
            </HeaderRow>
          </Col>
          <Col md={3}></Col>
        </Row>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  createCompanyList: state.company.createCompanyList,
  loading: state.company.loading,
  createSelected: state.company.createSelected,
})

const mapDispatchToProps = {
  companySelected,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompanySelect)
